import { EventBus } from "@/main.js";
import axios from "axios";

const LocaleUtils = {
    data() {
      return {
        pais: "",
        country_name: "BR | Português",
        country_code: "BR",
        country_list: [
          { country_code: "BR", idioma: "pt", sub: "Brazil", pais: "Brasil" },
          { country_code: "DE", idioma: "en", sub: "Germany", pais: "Alemanha" }, 
          { country_code: "AR", idioma: "es", sub: "Argentina", pais: "Argentina" },
          { country_code: "BO", idioma: "es", sub: "Bolivia", pais: "Bolívia" },
          // { country_code: "AU", idioma: "en", sub: "Australia", pais: "Austrália" },
          { country_code: "CA", idioma: "en", sub: "Canada", pais: "Canadá" },
          { country_code: "CL", idioma: "es", sub: "Chile", pais: "Chile" },
          { country_code: "CO", idioma: "es", sub: "Colombia", pais: "Colômbia" },
          // { country_code: "CR", idioma: "es", sub: "Costa Rica", pais: "Costa Rica" },
          // { country_code: "DO", idioma: "es", sub: "Dominican Republic", pais: "República Dominicana" },
          { country_code: "EC", idioma: "es", sub: "Ecuador", pais: "Equador" },
          { country_code: "ES", idioma: "es", sub: "Spain", pais: "Espanha" },
          { country_code: "FR", idioma: "en", sub: "France", pais: "França" },
          // { country_code: "GT", idioma: "es", sub: "Guatemala", pais: "Guatemala" },
          // { country_code: "HN", idioma: "en", sub: "Honduras", pais: "Honduras" },
          { country_code: "IT", idioma: "en", sub: "Italy", pais: "Itália" },
          { country_code: "IE", idioma: "en", sub: "Ireland", pais: "Irlanda" },
          // { country_code: "IL", idioma: "en", sub: "Israel", pais: "Israel" },
          // { country_code: "JP", idioma: "en", sub: "Japan", pais: "Japão" },
          // { country_code: "MY", idioma: "en", sub: "Malaysia", pais: "Malaysia" },
          { country_code: "MX", idioma: "es", sub: "Mexico", pais: "México" },
          // { country_code: "PA", idioma: "es", sub: "Panama", pais: "Panamá" },
          { country_code: "PE", idioma: "es", sub: "Peru", pais: "Peru" },
          // { country_code: "PR", idioma: "es", sub: "Puerto Rico", pais: "Porto Rico" },
          { country_code: "PT", idioma: "pt", sub: "Portugal", pais: "Portugal" },
          { country_code: "PY", idioma: "es", sub: "Paraguay", pais: "Paraguai" },
          { country_code: "GB", idioma: "en", sub: "United Kingdom", pais: "Reino Unido" },
          { country_code: "US", idioma: "en", sub: "United States", pais: "Estados Unidos" },
          { country_code: "UY", idioma: "es", sub: "Uruguay", pais: "Uruguai" },
        ],
        search: "",
        browser_country_code: null,  
        akamai_country_code: null,  
      };
    },
    computed: {
      akamaiCountry() {
        return this.akamai_country_code;
      }
    },
    methods:{
      setLocale(country_code) {
        let data = {
          country_code: country_code,
        };
        console.log('setLocale',data)
        EventBus.$emit("changeLocale", data);
      },
      selectCountry(country_code, update_country = false) {          
        if (update_country === true) { 
          localStorage.setItem("location", country_code);          
        }
        this.search = "";

        let country_exists = this.country_list.filter((item) => item.country_code === country_code);
        if(country_exists && country_exists.length) {
          this.$i18n.locale = country_exists[0].idioma;
        } else {
          if (update_country === true) EventBus.$emit("atualizaPais", { country_code: "BR" });
          this.$i18n.locale = "pt";
        }
      },
      async requestAkamaiLocale() {
        axios
          .get(process.env.VUE_APP_BASE_URL+"/getLocation")
          .then(async (response) => {
            console.log('requestAkamaiLocale', response);
            this.ip_address = response.data.getClientIP;
            await this.getAkamaiLocaleCode(response.data);
          })
          .catch((e) => {
            console.log('requestAkamaiLocale error',e);
          })
          .finally(() => {
          });
      },
      async getAkamaiLocaleCode(akamai_country) {
        if(await typeof akamai_country !== 'undefined' && await typeof akamai_country.getCountryCode !== 'undefined') {    
          if(await akamai_country.getCountryCode) {
            const country_code = await akamai_country.getCountryCode.toUpperCase();
            let country_exists = this.country_list.filter((item) => item.country_code === country_code);
    
            if(country_exists.length) {
              this.akamai_country_code = country_code;
              this.$i18n.locale = country_exists[0].idioma;
            } else if(!country_exists.length && country_code !== 'BR') {
              this.akamai_country_code = 'US';
              this.$i18n.locale = "en";
            } else if(!country_exists.length && country_code === 'BR') {
              this.akamai_country_code = 'BR';
              this.$i18n.locale = "pt";
            }
          } else {
            this.akamai_country_code = 'BR';
            this.$i18n.locale = "pt";
          }
        }
        return await this.akamai_country_code;
      },
      getBrowserLocaleCode(update_country = false) {
        const language = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
  
        if(language) {
          const country_code = language.slice(-2).toUpperCase();
          let country_exists = this.country_list.filter((item) => item.country_code === country_code);
  
          if(country_exists.length) {
            this.browser_country_code = country_code;
            this.$i18n.locale = country_exists[0].idioma;
          } else if(!country_exists.length && country_code !== 'BR') {
            this.browser_country_code = 'US';
            this.$i18n.locale = "en";
          } else if(!country_exists.length && country_code === 'BR') {
            this.browser_country_code = 'BR';
            this.$i18n.locale = "pt";
          }
        } else {
          this.browser_country_code = 'BR';
          this.$i18n.locale = "pt";
        }
        if(update_country) this.createLocale(update_country);
      },
      createLocale(update_country = false) {
        EventBus.$on("changeLocale", (data) => {
          localStorage.setItem("location", data.country_code);
          if(data && data.country_code) {
            this.selectCountry(data.country_code, update_country);
            if (update_country === true) { 
              let country_exists = this.country_list.filter((item) => item.country_code === data.country_code);
              if(country_exists && country_exists.length) {
                this.country_name = `${country_exists[0].country_code} | ${country_exists[0].pais}`;
                this.country_code = country_exists[0].country_code;
              } else {
                this.country_name = "BR | Português";
                this.country_code = "BR";
              }
            }
          } else {
            this.selectCountry("BR", update_country);
            if (update_country === true) { 
              this.country_name = "BR | Português";
              this.country_code = "BR";
            }
          }
        });
      }
    },
}

export default LocaleUtils